module.exports = __webpack_public_path__ + "img/my.18073c7f.png";